import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASEPATH_PORTAL } from '@/config/env.config';
import { createBaseQueryWithAuth } from '../baseQueryWithAuth';

export const portalApi = createApi({
	reducerPath: 'portal',
	tagTypes: ['projects', 'user', 'roles', 'users', 'files', 'admin-files', 'labVantageSummary', 'contacts', 'samplesets', 'pipelineStatus', 'pipelineStatusFacts', 'pipelineStatusRecords', 'pipelineStatusActivity', 'salesforcePendingUsers', 'salesforcePendingUserCount'],
  baseQuery: createBaseQueryWithAuth(API_BASEPATH_PORTAL),
  endpoints: () => ({}),
});